export default class ProfessorService {
  constructor(resource) {
    this._resource = resource;
  }

  getProfessores() {
    return this._resource.get(`corpore/professor`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter os professores");
      }
    );
  }

  getProfessoresByCurso(curso) {
    return this._resource.get(`corpore/professor/curso/${curso}`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter os professores");
      }
    );
  }

  getProfessoresByCodprof(codprof) {
    return this._resource.get(`corpore/professor/${codprof}`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter os professores");
      }
    );
  }

  getCodigoProfessorByCpf(cpf) {
    return this._resource.post(`corpore/professor/by/cpf`, {cpf}).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error(err.body);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/domain/corpore/ProfessorService.js